/**
 * PlanBadge — "Free plan · 1 of 1 repos connected" usage pill with a
 * book-a-demo link once the tenant is at its limit. Renders nothing for
 * unlimited (enterprise) tenants or before the plan endpoint has
 * answered, so it degrades silently against older backends.
 */

import { ExternalLink } from 'lucide-react';
import type { PlanUsage } from '@/services/githubApi';

/** Sales conversion entry point — the marketing contact page hosts the
 *  demo-request form. */
export const BOOK_DEMO_URL = 'https://www.systemdox.com/contact';

export function PlanBadge({ usage }: { usage: PlanUsage | null }) {
  if (!usage || usage.repo_limit === null) return null;
  const planLabel = usage.plan.charAt(0).toUpperCase() + usage.plan.slice(1);
  return (
    <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/60 px-3 py-1 text-xs text-slate-600 dark:text-slate-300 whitespace-nowrap">
      <span>
        {planLabel} plan &middot; {usage.connected_count} of {usage.repo_limit}{' '}
        {usage.repo_limit === 1 ? 'repo' : 'repos'} connected
      </span>
      {usage.at_limit && (
        <a
          href={BOOK_DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 font-medium text-blue-600 dark:text-blue-400 hover:underline"
        >
          Book a demo <ExternalLink className="w-3 h-3" />
        </a>
      )}
    </span>
  );
}
